/**
 * @generated SignedSource<<758380b694f86cd537d65b1e31a0a30c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LiveConversationsActivityStatusIndicator_query$data = {
  readonly csm_liveChatAgent: {
    readonly __typename: string;
    readonly id?: string;
    readonly liveChatActivitiesBySpace?: {
      readonly edges: ReadonlyArray<{
        readonly __typename: "CustomerServiceSpaceLiveChatActivityEdge";
      }>;
    } | null;
    readonly liveChatActivity?: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ActivityStatusIndicatorPresence_agent" | "ThrowOnQueryError">;
  } | null;
  readonly " $fragmentType": "LiveConversationsActivityStatusIndicator_query";
};
export type LiveConversationsActivityStatusIndicator_query$key = {
  readonly " $data"?: LiveConversationsActivityStatusIndicator_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"LiveConversationsActivityStatusIndicator_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "atlassianAccountId"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "LiveConversationsActivityStatusIndicator_query",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "accountId",
          "variableName": "atlassianAccountId"
        },
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "kind": "LinkedField",
      "name": "csm_liveChatAgent",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "id"
            },
            {
              "kind": "ScalarField",
              "name": "liveChatActivity"
            },
            {
              "concreteType": "CustomerServiceSpaceLiveChatActivitiesConnection",
              "kind": "LinkedField",
              "name": "liveChatActivitiesBySpace",
              "plural": false,
              "selections": [
                {
                  "concreteType": "CustomerServiceSpaceLiveChatActivityEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/)
                  ]
                }
              ]
            }
          ],
          "type": "CustomerServiceLiveChatAgent"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "ThrowOnQueryError"
            }
          ],
          "type": "QueryError"
        },
        {
          "kind": "FragmentSpread",
          "name": "ActivityStatusIndicatorPresence_agent"
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "6014f2b52557cb485c0e67a61e16f9cf";

export default node;
